(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hero-banner-text"] && !Shopify.designMode) return;
  try {
    (function () {
                   function fitSolowHeadings() {
                     document.querySelectorAll('.hero-cell__heading--solow').forEach(function (el) {
                       el.style.fontSize = '';
                       var container = el.closest('.hero-cell__content');
                       if (!container) return;

                       var style = getComputedStyle(container);
                       var availableWidth = container.clientWidth
                         - parseFloat(style.paddingLeft)
                         - parseFloat(style.paddingRight);

                       var size = parseFloat(getComputedStyle(el).fontSize);
                       var min = 10;

                       while (el.scrollWidth > availableWidth && size > min) {
                         size -= 0.5;
                         el.style.fontSize = size + 'px';
                       }
                     });
                   }

                   document.fonts.ready.then(function () {
                     fitSolowHeadings();

                     var ro = new ResizeObserver(fitSolowHeadings);
                     document.querySelectorAll('.hero-cell__content').forEach(function (el) {
                       ro.observe(el);
                     });
                   });
                 })();
  } catch(e) { console.error(e); }
})();

})();
